<template>
  <div class="dict-list dict-skeleton-list">
    <article
      v-for="n in 3"
      :key="'skel-' + n"
      class="dict-card dict-card--skeleton"
      aria-hidden="true"
    >
      <div class="dict-mapping-rows">
        <div class="dict-mapping-row">
          <span class="dict-skeleton__line"></span>
        </div>
        <div class="dict-mapping-row">
          <span class="dict-skeleton__line dict-skeleton__line--short"></span>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'LoadingPlaceholder'
}
</script>
